import pathReq from '@/api/pathlist'

const loadOptions = {
  lock: true,
  text: '加载中',
  spinner: 'el-icon-loading',
  background: 'rgba(0, 0, 0, 0.5)'
}

function tableDateTimeFormat(datetime) {
  if (!datetime) return ''

  var ret = datetime.replace('T', ' ')
  if (ret.length >= 19) {
    return ret.substr(0, 19)
  } else {
    return ret
  }
}

function tableDateFormat(datetime) {
  if (!datetime) return ''
  if (datetime.length < 10) return ''
  return datetime.substr(0, 10)
}

function tableDecFormat(val) {
  if (isNaN(val)) return ''
  // eslint-disable-next-line no-new-wrappers
  const num = new Number(val)
  return num.toFixed(2)
}

function formatJson(filterVal, jsonData) {
  return jsonData.map(v =>
    filterVal.map(j => {
      return v[j]
    })
  )
}
function formatObj(filterVal, data) {
  var result = {}
  for (var i = 0; i < filterVal.length; i++) {
    if (data) {
      result[filterVal[i]] = data[i]
    }
  }
  return result
}
// 根据下拉框Text取得Value
function getComboxKeyByText(text, srcArray) {
  for (const item of srcArray) {
    if (item.label.replace('*', '') === text) {
      return item.value
    }
  }
  return null
}
// 根据下拉框Text取得Value
function getComboxTextByKey(text, srcArray) {
  for (const item of srcArray) {
    if (item.value.replace('*', '') === text) {
      return item.label
    }
  }
  return null
}

/** 当前登录身份 */
function getUserIdentity() {
  return localStorage.getItem('UserSelectedIdentity')
}

/** 取得实体 */
function saveRowEntity(moduleCode, row, handleSearch) {
  // 因为列表中的数据是不全的，需要从数据库中取一次，然后再保存
  var path = ''
  if (row.id) {
    // 修改的时候，id是有数据的
    path = '/api/services/app/' + moduleCode + '/GetEdit' + moduleCode + '?Id=' + row.id
  } else {
    // 新增的时候，id没有数据
    path = '/api/services/app/' + moduleCode + '/GetEdit' + moduleCode
  }
  pathReq.getNoParams(path).then((res) => {
    // 取得数据库中该数据
    var entity = res.data.result.entityData
    // 复制对象
    var formData = Object.assign(entity, row)
    path = '/api/services/app/' + moduleCode + '/CreateOrUpdate' + moduleCode
    // 保存
    pathReq.postForm(path, { entityData: formData }).then(res => {
      if (res.status === 200) {
        if (res.data.success) {
          handleSearch()
        }
      }
    })
  })
}

export default {
  loadOptions,
  tableDateFormat,
  tableDateTimeFormat,
  tableDecFormat,
  formatJson,
  formatObj,
  getComboxKeyByText,
  getComboxTextByKey,
  getUserIdentity,
  saveRowEntity
}
